import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, computed, effect, inject, model, signal } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ActivatedRoute } from '@angular/router';
import { BottomSheetSaveCancelComponent } from 'src/app/components/bottom-sheet-save-cancel/bottom-sheet-save-cancel.component';
import { AppstateService } from 'src/app/services/appstate.service';
import { BudgetDetailsService } from 'src/app/services/budget-details.service';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserService } from 'src/app/services/user.service';
import { Budgetantrag } from 'src/app/types/Budgetantrag';
import { IWirtschaftsplan } from 'src/app/types/IWirtschaftsplan';
import { IBudgetantragViewmodel } from 'src/app/types/viewmodels/budgetantrag.viewmodel';

@Component({
  selector: 'app-budget-details',
  // standalone: true,
  // imports: [],
  templateUrl: './budget-details.component.html',
  styleUrl: './budget-details.component.css'
})
export class BudgetDetailsComponent implements OnInit, OnDestroy {

  @Input()
  set projektid(id: number) {
    if (id) {
      this.appStateService.projektId.set(id);
      this.appStateService.projektInfoId.set(id);
    }
  }
  @Input()
  set baid(id: number) {
    this.appStateService.budgetantragId.set(id);
  }


   private sheetSaveCancel?: MatBottomSheetRef<BottomSheetSaveCancelComponent>;

  constructor(private activeRoute: ActivatedRoute,
    private dataService: DataService,
    public navigationService: NavigationService,
    private appStateService: AppstateService,
    private dialogService: DialogService,
    private userService: UserService,
    public budgetService: BudgetDetailsService
  ) {

    effect(() => {
      // get data from service
      this.DataLoad();
    }, { allowSignalWrites: true });

    effect(() => {
      if (this.budgetService.antragValueChanged()) {

        if (this.sheetSaveCancel && this.sheetSaveCancel.componentRef) {
          this.sheetSaveCancel!.componentRef!.instance.saveDisabled = !this.budgetService.IsDataValid();
        }
      }
    });

    effect(() => {
      // changes detected
      if (this.budgetService.antragChanged() || this.budgetService.antragLageplanChanged()) {

        this.sheetSaveCancel = this.dialogService.showSaveChangesSheet();
        var componentRef = this.sheetSaveCancel.componentRef?.instance;

        // opened
        this.sheetSaveCancel.afterOpened().subscribe(() => {
          componentRef!.saveDisabled = !this.budgetService.IsDataValid();
        });

        // save clicked
        componentRef?.actionClicked.subscribe(() => {
          // validate
          if (!this.budgetService.ValidateBeforeSave()) {
            //componentRef!.saveDisabled = true;
            return;
          }
          else {
            // POST
            this.dataService.updateBudgetantrag(this.appStateService.budgetantragId()!, this.budgetService.antrag()).subscribe({
              next: (dataBudgetantrag: HttpResponse<Budgetantrag>) => {
                if (this.budgetService.antragLageplanChanged()) {
                  if (this.budgetService.antragLageplan()) {
                    // UPDATE
                    const formData = new FormData();
                    formData.append("file", this.budgetService.antragLageplan()!, this.budgetService.antrag().lageplanDateiname);
                    this.dataService.updateBudgetantragLageplan(this.appStateService.budgetantragId()!, formData).subscribe({
                      next: (data) => {
                  		dataBudgetantrag.body!.lageplanDateiname = data;
                        this.DataSaved();
                      },
                      error: (err: HttpErrorResponse) => { }
                    });
                  } else {
                    this.dataService.deleteBudgetantragLageplan(this.appStateService.budgetantragId()!).subscribe({
                      next: (data) => {
                        this.DataSaved();
                      },
                      error: (err: HttpErrorResponse) => { }
                    });
                  }
                } else {
                  this.DataSaved();
                }
              },
              error: (err: HttpErrorResponse) => { }
            });
          }
        });

        // cancel clicked
        this.sheetSaveCancel.afterDismissed().subscribe((data) => {
          if (data && data.action == 'Cancel') {
            // reset data
            this.DataCanceled();
          }
        });
      }
    }, { allowSignalWrites: true });
  }

 

 
  private DataLoad() {
    // copy data to model
    this.budgetService.antrag.set({ ...this.dataService.budgetantragDetails() });
    this.budgetService.wirtschaftsplaene.set(this.dataService.wirtschaftsplaene());
    var file = this.dataService.budgetantragDetailsLageplan();
    this.budgetService.antragLageplan.set(new File([file], file.name, { type: file.type, lastModified: file.lastModified }));
  }

  private DataCanceled() {
    this.DataLoad();
    this.budgetService.antragChanged.set(false);
    this.budgetService.antragLageplanChanged.set(false);
    this.dialogService.showMessageSheet('Die Änderungen am Budgetantrag wurde verworfen');
  }

  private DataSaved() {
    this.sheetSaveCancel!.dismiss();
    this.budgetService.antragChanged.set(false);
    this.budgetService.antragLageplanChanged.set(false);
    this.dialogService.showMessageSheet('Der Budgetantrag wurde erfolgreich aktualisiert');
  }

  private DataDeleted() {
    this.dialogService.showMessageSheet('Der Antrag wurde erfolgreich gelöscht');
    this.navigationService.navigateToProjektDetails(this.appStateService.projektInfoId());
  }

  
  ngOnInit() {
    // initializing again, is not working in declaration
    this.budgetService.antrag.set(Budgetantrag.default);
    this.budgetService.antragLageplan.set(new File([], ''));
  }

  BackButtonClick() {
    this.navigationService.navigateBackToBudgetantragDashboard(this.activeRoute);
  }

  DeleteButtonClick() {
    this.dialogService.showDialog('Möchten Sie den Budgetantrag wirklich löschen?', 'Budgetantrag löschen').subscribe(result => {
      if (result == true) {
        this.dataService.deleteBudgetantragLageplan(this.appStateService.budgetantragId()!).subscribe({
          next: (data) => {
            this.dataService.deleteBudgetantrag(this.appStateService.budgetantragId()!).subscribe({
              next: (data) => {
                this.DataDeleted();
              },
              error: (err: HttpErrorResponse) => { }
            });
          },
          error: (err: HttpErrorResponse) => { }
        });
      }
    });
  }

  onLageplanPdfClick() {
	const url = this.budgetService.antragLageplanUrl();
	if (!url) return;

	window.open(url, '_blank', 'noopener,noreferrer');
  }
  
  ngOnDestroy() {
    // if changes are not saved, dismiss sheet
    if (this.budgetService.antragChanged() || this.budgetService.antragLageplanChanged()) {
      this.sheetSaveCancel?.dismiss();
      this.dialogService.showMessageSheet('Die Änderungen am Budgetantrag wurde verworfen');
    }
  }

}
